export default __webpack_public_path__ + "static/media/not_covered_icon.7514b44b.png";